export default {"src":"/login-app/[GIT_HASH]/_next/static/media/cloud.1633ef9a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};